import { render, staticRenderFns } from "./orderlistIndex.vue?vue&type=template&id=f760699a&scoped=true&"
import script from "./orderlistIndex.vue?vue&type=script&lang=js&"
export * from "./orderlistIndex.vue?vue&type=script&lang=js&"
import style0 from "./orderlistIndex.vue?vue&type=style&index=0&id=f760699a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f760699a",
  null
  
)

export default component.exports